import styled from 'styled-components/macro';

export const LocationDispalyWrapper = styled.div`
    width: 100%;
    height: 100%;
    background-color: #a19f9d;
    overflow: hidden;
    position: relative;
`;

export const ImageLoadingWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5;
`;
